"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InputGroupAdapter = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _InputGroup = require("../InputGroup");

var _FormikAdapter = require("./FormikAdapter");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var InputGroupAdapter =
/*#__PURE__*/
function (_React$Component) {
  _inherits(InputGroupAdapter, _React$Component);

  function InputGroupAdapter(props) {
    var _this;

    _classCallCheck(this, InputGroupAdapter);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(InputGroupAdapter).call(this, props));
    _this.state = {
      focused: false
    };
    _this.handleFocus = _this.handleFocus.bind(_assertThisInitialized(_this));
    _this.handleBlur = _this.handleBlur.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(InputGroupAdapter, [{
    key: "handleFocus",
    value: function handleFocus() {
      this.setState({
        focused: true
      });
    }
  }, {
    key: "handleBlur",
    value: function handleBlur() {
      this.setState({
        focused: false
      });
    }
  }, {
    key: "render",
    value: function render() {
      var focused = this.state.focused;
      var _this$props = this.props,
          field = _this$props.field,
          form = _this$props.form,
          atts = _this$props.atts,
          label = _this$props.label,
          helper = _this$props.helper,
          cashbotName = _this$props.cashbotName,
          isRequiredField = _this$props.isRequiredField,
          hasMaxLengthCounter = _this$props.hasMaxLengthCounter,
          counterAriaLabel = _this$props.counterAriaLabel,
          wrappedElement = _this$props.wrappedElement,
          showUntouchedErrors = _this$props.showUntouchedErrors,
          doFocus = _this$props.doFocus,
          format = _this$props.format,
          showHelper = _this$props.showHelper,
          submitButton = _this$props.submitButton;
      return _react.default.createElement(_FormikAdapter.FormikAdapter, {
        field: field,
        form: form,
        options: {
          atts: atts,
          handleFocus: this.handleFocus,
          handleBlur: this.handleBlur,
          format: format
        },
        render: function render(props) {
          return _react.default.createElement(_InputGroup.InputGroup, _extends({}, props, {
            label: label,
            helper: helper,
            cashbotName: cashbotName,
            hasMaxLengthCounter: hasMaxLengthCounter,
            counterAriaLabel: counterAriaLabel,
            isActive: focused,
            isRequiredField: isRequiredField,
            wrappedElement: wrappedElement,
            showUntouchedErrors: showUntouchedErrors,
            doFocus: doFocus,
            showHelper: showHelper,
            submitButton: submitButton
          }));
        }
      });
    }
  }]);

  return InputGroupAdapter;
}(_react.default.Component);

exports.InputGroupAdapter = InputGroupAdapter;
InputGroupAdapter.defaultProps = {
  doFocus: false,
  helper: '',
  hasMaxLengthCounter: false,
  counterAriaLabel: null,
  isRequiredField: true,
  showUntouchedErrors: false,
  wrappedElement: null,
  // optional element icon/image inside FieldDivWrapper for positioning
  format: null,
  showHelper: false,
  submitButton: null
};
InputGroupAdapter.propTypes = {
  atts: _propTypes.default.shape({
    maxLength: _propTypes.default.number.isRequired,
    type: _propTypes.default.oneOf(['email', 'tel', 'text'])
  }).isRequired,
  field: _propTypes.default.object.isRequired,
  form: _propTypes.default.object.isRequired,
  helper: _propTypes.default.string,
  label: _propTypes.default.string.isRequired,
  cashbotName: _propTypes.default.string.isRequired,
  hasMaxLengthCounter: _propTypes.default.bool,
  counterAriaLabel: function counterAriaLabel(props, propName, componentName) {
    return props.hasMaxLengthCounter && (props[propName] === undefined || typeof props[propName] !== 'function') ? new Error("".concat(propName, " must be a function when hasMaxLengthCounter is true (component: ").concat(componentName, ")")) : undefined;
  },
  isRequiredField: _propTypes.default.bool,
  showUntouchedErrors: _propTypes.default.bool,
  wrappedElement: _propTypes.default.node,
  doFocus: _propTypes.default.bool,
  format: _propTypes.default.func,
  showHelper: _propTypes.default.bool,
  submitButton: _propTypes.default.shape({
    btnText: _propTypes.default.string.isRequired,
    onClick: _propTypes.default.func.isRequired
  })
};